/**
 * Side-effect module: configures the global axios defaults used by legacy
 * actions/* that call `axios.get|post` directly (instead of importing
 * api/client.ts). Imported once at app bootstrap.
 */
import axios from "axios";
import { installPublicAccess } from "./publicAccess";

const apiUrl = import.meta.env.REACT_APP_API_URL as string | undefined;
if (apiUrl) {
  axios.defaults.baseURL = apiUrl;
}
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";

installPublicAccess();
